type MiniSplitRoomsIconProps = {
  value: string;
  selected?: boolean;
};

function getRoomCount(value: string) {
  const match = String(value).match(/\d+/);
  return match ? Number(match[0]) : 0;
}

export function MiniSplitRoomsIcon({
  value,
  selected = false,
}: MiniSplitRoomsIconProps) {
  const rooms = Math.max(1, Math.min(6, getRoomCount(value)));
  const activeFill = selected ? "var(--brand)" : "#6b7280";
  const mutedFill = "#d1d5db";
  const stroke = selected ? "var(--brand)" : "#9ca3af";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="shrink-0"
    >
      <path
        d="M4 10.2 12 4l8 6.2V20H4z"
        fill="none"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M7 12.5h3v2.8H7zm0 4h3v2.8H7zm4 0h3v2.8h-3zm4 0h3v2.8h-3zm4-4h-3v2.8h3zm-8 0h3v2.8h-3z"
        fill={mutedFill}
      />
      {Array.from({ length: rooms }).map((_, idx) => {
        const positions = [
          { x: 7, y: 12.5 },
          { x: 11, y: 12.5 },
          { x: 15, y: 12.5 },
          { x: 7, y: 16.5 },
          { x: 11, y: 16.5 },
          { x: 15, y: 16.5 },
        ];
        const pos = positions[idx];
        return <rect key={idx} x={pos.x} y={pos.y} width="3" height="2.8" fill={activeFill} />;
      })}
    </svg>
  );
}
